// routes/_authed.tsx - Layout route for protected pages
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { currentUserQueryOptions } from '~ai-tutor/lib/serverFunctions/auth';

const PATHS_WITHOUT_CHAT_REDIRECT = new Set(['/chat', '/settings', '/oidc/redeem-token']);

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.fetchQuery(currentUserQueryOptions());

    if (!user.authenticated) return {};

    // OIDC: pass through identity info; conversation selection happens in child routes
    return {
      user,
    };
  },
  loader: ({ location, context }) => {
    // Not logged in yet (token or oidc) -> send to login page
    if (!context.user?.authenticated) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }

    // Already have a conversationId -> go to chat using this conversation
    // Skip when already navigating to a route that must stay reachable with a conversation
    // present, otherwise those routes bounce to /chat
    if (context.user.conversationId && !PATHS_WITHOUT_CHAT_REDIRECT.has(location.pathname)) {
      throw redirect({
        to: '/chat',
      });
    }
  },
  component: Outlet,
});
